import ReactMarkdown from "react-markdown";
import type { LeoMessage as LeoMessageType } from "@/stores/leo-chat.store";

interface LeoMessageProps {
  message: LeoMessageType;
}

export function LeoMessage({ message }: LeoMessageProps) {
  const isBot = message.role === "assistant";
  const time = message.timestamp.toLocaleTimeString("pt-BR", {
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <div
      className={`flex gap-2 max-w-[92%] ${isBot ? "self-start" : "self-end flex-row-reverse"}`}
    >
      <div
        className={`w-7 h-7 rounded-full flex-shrink-0 flex items-center justify-center text-xs font-bold text-white ${
          isBot
            ? "bg-gradient-to-br from-purple-600 to-purple-400"
            : "bg-gradient-to-br from-purple-600 to-purple-500"
        }`}
      >
        {isBot ? "L" : "U"}
      </div>
      <div className="flex flex-col">
        <div
          className={`px-3.5 py-2.5 rounded-2xl text-[13px] leading-relaxed whitespace-pre-wrap ${
            isBot
              ? "bg-gray-100 text-gray-700 rounded-bl-sm"
              : "bg-purple-600 text-white rounded-br-sm"
          }`}
        >
          <ReactMarkdown
            components={{
              p: ({ children }) => <p className="mb-1 last:mb-0">{children}</p>,
              strong: ({ children }) => <strong className="font-semibold">{children}</strong>,
              ul: ({ children }) => <ul className="list-disc pl-4 mb-1">{children}</ul>,
              ol: ({ children }) => <ol className="list-decimal pl-4 mb-1">{children}</ol>,
              li: ({ children }) => <li className="mb-0.5">{children}</li>,
              a: ({ href, children }) => (
                <a href={href} className="text-purple-600 underline" target="_blank" rel="noopener noreferrer">
                  {children}
                </a>
              ),
            }}
          >
            {message.content}
          </ReactMarkdown>
        </div>
        <span className="text-[10px] text-gray-400 mt-1 px-0.5">{time}</span>
      </div>
    </div>
  );
}
